import { View, XStack } from "tamagui";
import { useDebouncedCallback } from "use-debounce";

import { SearchInput } from "~/components/blocks";
import { useGroupsFilter } from "~/components/blocks/filters/groups-filter";
import { AddGroupDialog } from "./add-group-dialog";

export const GroupsHeader = () => {
  const { dispatch } = useGroupsFilter();
  const handleSearchInput = useDebouncedCallback(
    (input: string) =>
      dispatch({ type: "SET_FILTER", filterName: "search", value: input }),
    300,
  );

  return (
    <XStack justifyContent="space-between" alignItems="flex-start">
      <View alignItems="flex-start" gap={"$3"}>
        <AddGroupDialog />
      </View>

      <SearchInput maxWidth={400} onChangeText={handleSearchInput} />
    </XStack>
  );
};
